import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const STORAGE_KEY = 'darkMode';
const DARK_CLASS = 'dark-mode';

@Injectable({ providedIn: 'root' })
export class DarkModeService {
  private isDark: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() {
    this.apply(localStorage.getItem(STORAGE_KEY) === 'true');

    // Vários layouts/telas sobrescrevem document.body.className, apagando a classe do tema.
    // Reaplica a classe sempre que ela for removida enquanto o dark mode estiver ativo.
    new MutationObserver(() => {
      if (this.isDark.value && !document.body.classList.contains(DARK_CLASS)) {
        document.body.classList.add(DARK_CLASS);
      }
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  public getIsDark() {
    return this.isDark;
  }

  public toggle(): void {
    this.apply(!this.isDark.value);
  }

  private apply(value: boolean): void {
    this.isDark.next(value);
    document.body.classList.toggle(DARK_CLASS, value);
    localStorage.setItem(STORAGE_KEY, String(value));
  }
}
